import { render, staticRenderFns } from "./Biological.vue?vue&type=template&id=28080604&scoped=true&"
import script from "./Biological.vue?vue&type=script&lang=js&"
export * from "./Biological.vue?vue&type=script&lang=js&"
import style0 from "./Biological.vue?vue&type=style&index=0&id=28080604&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28080604",
  null
  
)

export default component.exports